import { render, staticRenderFns } from "./AutomationList.vue?vue&type=template&id=e95ff208"
import script from "./AutomationList.vue?vue&type=script&lang=js"
export * from "./AutomationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports